import React, { useState, useEffect } from 'react'
import { CheckCircle, X, AlertCircle, Info } from 'lucide-react'

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
      setTimeout(onClose, 300) // Aguarda a animação de saída
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onClose])

  const handleClose = () => {
    setIsVisible(false)
    setTimeout(onClose, 300)
  }

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="w-5 h-5" />
      case 'error':
        return <AlertCircle className="w-5 h-5" />
      case 'info':
        return <Info className="w-5 h-5" />
      default:
        return <CheckCircle className="w-5 h-5" />
    }
  }

  const getColors = () => {
    switch (type) {
      case 'success':
        return 'bg-gradient-to-r from-green-500 to-emerald-600 border-green-400 text-white'
      case 'error':
        return 'bg-gradient-to-r from-red-500 to-rose-600 border-red-400 text-white'
      case 'info':
        return 'bg-gradient-to-r from-blue-500 to-indigo-600 border-blue-400 text-white'
      default:
        return 'bg-gradient-to-r from-green-500 to-emerald-600 border-green-400 text-white'
    }
  }

  return (
    <div
      className={`fixed top-4 right-4 z-50 max-w-sm w-full transition-all duration-500 ease-in-out transform ${
        isVisible ? 'translate-x-0 opacity-100 scale-100' : 'translate-x-full opacity-0 scale-95'
      }`}
    >
      <div className={`border rounded-xl p-4 shadow-2xl backdrop-blur-sm ${getColors()}`}>
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <div className="p-1 rounded-full bg-white bg-opacity-20">
              {getIcon()}
            </div>
          </div>
          <div className="ml-3 flex-1">
            <p className="text-sm font-semibold leading-relaxed">{message}</p>
          </div>
          <div className="ml-4 flex-shrink-0">
            <button
              onClick={handleClose}
              className="inline-flex text-white text-opacity-70 hover:text-opacity-100 focus:outline-none transition-all duration-200 hover:scale-110"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 h-1 bg-white bg-opacity-30 rounded-b-xl animate-pulse" style={{width: '100%'}}></div>
      </div>
    </div>
  )
}

export default Toast